import { render, staticRenderFns } from "./LatestProjects.vue?vue&type=template&id=7f356c15&scoped=true"
import script from "./LatestProjects.vue?vue&type=script&lang=js"
export * from "./LatestProjects.vue?vue&type=script&lang=js"
import style0 from "./LatestProjects.vue?vue&type=style&index=0&id=7f356c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f356c15",
  null
  
)

export default component.exports